/**
 * 用于定义 id 静态变量，在 e2e 中使用这些 id 进行定位
 */

export const CANVAS_SLIDE_ID_PREFIX = 'slide-canvas';

export const CANVAS_SHAPE_ID_PREFIX = 'canvas-shape';

export const CANVAS_IMAGE_ID_PREFIX = 'canvas-image';

export const CANVAS_IMAGE_FOREGROUND_ID_PREFIX = 'canvas-img-foreground';

export const CANVAS_GROUP_ID_PREFIX = 'canvas-group';

export const CANVAS_CHART_ID_PREFIX = 'canvas-chart';

export const CANVAS_CHART_COMPONENT_ID_PREFIX = 'canvas-chart-component';

export const CANVAS_SMART_ART_ID_PREFIX = 'canvas-smart-art-component';

// canvas 文字编辑器
export const CANVAS_TEXT_EDITOR_ID_PREFIX = 'canvas-text-editor';

// canvas 文字节点
export const CANVAS_RECT_TEXT_ID = 'canvas-rect-text';

// canvas 文本中图片节点
export const CANVAS_TEXT_IMAGE_ID = 'canvas-text-image';

// canvas 文字链接节点
export const CANVAS_LINK_TEXT_ID = 'canvas-link-text';

// canvas 艺术字组件
export const CANVAS_WORD_ART_COMPONENT_ID = 'canvas-word-art-component';
// canvas 艺术字图像节点
export const CANVAS_WORD_ART_GRAPHICS_ID = 'canvas-word-art-graphics';
// canvas 艺术字事件区域节点
export const CANVAS_WORD_ART_EVENT_AREA_ID = 'canvas-word-art-event-area';

// canvas 表格
export const CANVAS_TABLE_ID_PREFIX = 'canvas-table-node';

// canvas 表格单元格
export const CANVAS_TABLE_CELL_ID_PREFIX = 'canvas-table-cell';

// canvas 表格单元格背景
export const CANVAS_TABLE_CELL_BG_ID_PREFIX = 'canvas-table-bg-cell';

// canvas 表格单元格选中
export const CANVAS_TABLE_CELL_SELECT_ID_PREFIX = 'canvas-table-select-cell';

// canvas 表格单元格容器
export const CANVAS_TABLE_CELL_CONTAINER_ID = 'canvas-table-container-cell';

// canvas 表格单元格边框
export const CANVAS_TABLE_BORDER_ID_PREFIX = 'canvas-table-border';

// canvas place holder占位创建表格小图标
export const CANVAS_PLACEHOLDER_TABLE_ID = 'canvas_placeholder_table';

// canvas  place holder占位创建img小图标
export const CANVAS_PLACEHOLDER_IMG_ID = 'canvas_placeholder_img';

// canvas PathRenderComponent节点
export const CANVAS_PATH_RENDER_ID = 'canvas-path-render';
// 动画wrapper
export const CANVAS_ANIM_WRAPPER = 'canvas-anim-wrapper';

export const CANVAS_WRAPPER = 'canvas-wrapper';

export const CANVAS_PLAYER_ID = 'slide-player-canvas';

export const CANVAS_CONNECTOR_ID = 'canvas-connector';
